import React, { useEffect, useRef } from 'react'

export function Confetti({ trigger, onDone }: { trigger: number; onDone?: () => void }) {
  const ref = useRef<HTMLCanvasElement | null>(null)
  useEffect(() => {
    if (!trigger) return
    const c = ref.current
    if (!c) return
    let raf = 0
    const ctx = c.getContext('2d')!
    const dpr = Math.min(2, window.devicePixelRatio || 1)
    const resize = () => { c.width = c.clientWidth * dpr; c.height = c.clientHeight * dpr }
    resize()
    const colors = ['#ff6b6b','#ffd166','#06d6a0','#1b9aaa','#c77dff']
    const parts = Array.from({ length: 120 }, () => ({
      x: Math.random() * c.width,
      y: -Math.random() * 100,
      vx: (Math.random() - 0.5) * 2,
      vy: Math.random() * 2 + 2,
      rot: Math.random() * Math.PI,
      vr: (Math.random() - 0.5) * 0.2,
      size: Math.random() * 6 + 3,
      color: colors[Math.floor(Math.random()*colors.length)]
    }))
    const t0 = performance.now()
    const loop = () => {
      const now = performance.now()
  ;(loop as any).last = now
      ctx.setTransform(dpr,0,0,dpr,0,0)
      ctx.clearRect(0,0,c.width,c.height)
      parts.forEach(p => {
        p.x += p.vx
        p.y += p.vy
        p.rot += p.vr
        ctx.save()
        ctx.translate(p.x, p.y)
        ctx.rotate(p.rot)
        ctx.fillStyle = p.color
        ctx.fillRect(-p.size/2, -p.size/2, p.size, p.size)
        ctx.restore()
      })
      raf = requestAnimationFrame(loop)
      if (now - t0 > 1800) { cancelAnimationFrame(raf); onDone && onDone() }
    }
    raf = requestAnimationFrame(loop)
    return () => cancelAnimationFrame(raf)
  }, [trigger, onDone])
  return <canvas ref={ref} style={{ position:'fixed', inset:0, pointerEvents:'none', width:'100%', height:'100%', zIndex:99 }} />
}
